import _classCallCheck from "babel-runtime/helpers/classCallCheck";

var ResultInt = function ResultInt(code, info, data) {
    _classCallCheck(this, ResultInt);

    this.retCode = code;
    this.retInfo = info;
    if (data !== null) {
        this.retData = data;
    }
};

export default ResultInt;